var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTextFieldsIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6667 0.333496H1.33333C0.73425 0.333496 0.25 0.817746 0.25 1.41683V4.66683C0.25 5.26591 0.73425 5.75016 1.33333 5.75016C1.93242 5.75016 2.41667 5.26591 2.41667 4.66683V2.50016H8.91667V16.5835H6.75C6.15092 16.5835 5.66667 17.0677 5.66667 17.6668C5.66667 18.2659 6.15092 18.7502 6.75 18.7502H13.25C13.8491 18.7502 14.3333 18.2659 14.3333 17.6668C14.3333 17.0677 13.8491 16.5835 13.25 16.5835H11.0833V2.50016H17.5833V4.66683C17.5833 5.26591 18.0676 5.75016 18.6667 5.75016C19.2658 5.75016 19.75 5.26591 19.75 4.66683V1.41683C19.75 0.817746 19.2658 0.333496 18.6667 0.333496Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextFieldsIcon);
export default __webpack_public_path__ + "static/media/textFieldsIcon.f1cfd3d856791253fecd24b2efc84471.svg";
export { ForwardRef as ReactComponent };